import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import { Container, Wrapper } from 'components/CopyrightStyles';

const Copyright = () => {
  const data = useStaticQuery(graphql`
    query copyrightYearQuery {
      site {
        siteMetadata {
          copyrightYear
        }
      }
    }
  `);

  return (
    <Wrapper>
      <Container>
        <small>
          &copy; {data.site.siteMetadata.copyrightYear} DataCamp Inc.
        </small>
      </Container>
    </Wrapper>
  );
};

export default Copyright;
